import React from 'react';

export function ErrorMessage() {
  return (
    <div className="h-100 d-flex justify-content-center align-items-center text-center">
      <span className="h4 fw-bold text-danger mb-0">Oops, hubo un error en la carga de los datos</span>
    </div>
  );
}
